import Styles from './styles.module.css';
import React, { useEffect, useState } from 'react';
import { collection, getFirestore, onSnapshot, query, where } from 'firebase/firestore';
import { useAppSelector } from 'src/salon/app/hook';
import { PhotoRow, StaffOption, toPhotoRow } from './types';
import PhotoGallery from './0.gallery/index';
import PhotoEditDrawer from './2.edit/index';
import PhotoUploadDialog from './1.post/index';

// 元 5.photo/index.tsx から移動。uploadOpen/setUploadOpenは以前は親シェル
// (desktop/index.tsx)のヘッダーボタンが持っていたが、サロンPRの他タブ
// (スタッフ/説明会/クーポン)と同じく、タブ自身の「＋」ボタンで開閉するように
// このタブ内のローカル状態に変更した。Firestore取得・アップロード・編集ロジックは変更していない。
const Photo: React.FC = () => {

  const company = useAppSelector((state) => state.company.company);

  const [ uploadOpen, setUploadOpen ] = useState(false);

  const [ rows, setRows ] = useState<PhotoRow[]>([]);
  const [ loading, setLoading ] = useState<boolean>(true);
  const [ staffList, setStaffList ] = useState<StaffOption[]>([]);

  const [ selectedId, setSelectedId ] = useState<string | null>(null);

  const [ time, setTime ] = useState<number>(0);

  useEffect(() => {
    setTime(new Date().getTime());

    if (!company.id) return;

    const db = getFirestore();
    const queryRef = query(collection(db, 'posts'), where('companyId', '==', company.id));

    const unsub = onSnapshot(queryRef, (snapshot) => {
      const tmp = snapshot.docs
        .map((d) => toPhotoRow(d.id, d.data()))
        .filter((row) => !row.post_student);
      setRows(tmp);
      setLoading(false);
    }, (error) => {
      console.error('fetch posts realtime error', error);
      setLoading(false);
    });

    return () => unsub();
  }, [company.id]);

  useEffect(() => {
    if (!company.id) return;

    const db = getFirestore();
    const queryRef = query(collection(db, 'staffProfiles'), where('companyId', '==', company.id));

    const unsub = onSnapshot(queryRef, (snapshot) => {
      const tmp: StaffOption[] = snapshot.docs.map((d) => ({
        id: d.id,
        docId: d.data().docId ?? '',
        name: d.data().name ?? '',
        position: d.data().position ?? '',
      }));
      setStaffList(tmp);
    });

    return () => unsub();
  }, [company.id]);

  // アップロードダイアログ・編集パネルが閉じたら画像URLを更新して再試行(リサイズ処理の完了待ち)
  useEffect(() => {
    if (!uploadOpen && !selectedId) {
      setTime(new Date().getTime());
      const timer = setTimeout(() => {
        setTime(new Date().getTime());
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [uploadOpen, selectedId]);

  // 選択中の作品が(別セッションでの削除等により)一覧から消えたらパネルを閉じる
  useEffect(() => {
    if (!loading && selectedId && !rows.some((r) => r.id === selectedId)) {
      setSelectedId(null);
    }
  }, [rows, loading, selectedId]);

  const selectedRow = rows.find((r) => r.id === selectedId) ?? null;
  const panelOpen = selectedId !== null && selectedRow !== null;

  return (
    <>
    <div className={panelOpen ? Styles.outer_open : Styles.outer}>

      <div className={panelOpen ? Styles.works_service_open : Styles.works_service}>
        <PhotoGallery
          rows={rows}
          staffList={staffList}
          time={time}
          loading={loading}
          onSelect={setSelectedId}
          onOpenUpload={() => setUploadOpen(true)}
        />
      </div>

      {panelOpen && selectedRow && (
        <div className={Styles.nav_open}>
          <PhotoEditDrawer
            row={selectedRow}
            staffList={staffList}
            time={time}
            onClose={() => setSelectedId(null)}
          />
        </div>
      )}

    </div>

    {uploadOpen && (
      <PhotoUploadDialog staffList={staffList} onClose={() => setUploadOpen(false)} />
    )}
    </>
  );
}

export default Photo;
